import { Text, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import DateInput from './DateInput';

export default function DateFilterBar({ filters, onChange, onApply, onClear }) {
  return (
    <View className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <View className="mb-3 flex-row items-center justify-between">
        <Text className="font-bold text-slate-950">Date filters</Text>
        <TouchableOpacity className="flex-row items-center" onPress={onClear}>
          <MaterialIcons name="restart-alt" size={18} color="#64748b" />
          <Text className="ml-1 text-sm font-semibold text-slate-500">Clear</Text>
        </TouchableOpacity>
      </View>
      <View className="gap-3">
        <DateInput
          value={filters.start}
          onChangeText={(value) => onChange({ ...filters, start: value })}
          className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-950"
          placeholder="Start date"
        />
        <DateInput
          value={filters.end}
          onChangeText={(value) => onChange({ ...filters, end: value })}
          className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-950"
          placeholder="End date"
        />
      </View>
      <TouchableOpacity className="mt-3 rounded-2xl bg-slate-900 px-4 py-3" onPress={onApply}>
        <Text className="text-center font-bold text-white">Apply filter</Text>
      </TouchableOpacity>
    </View>
  );
}
